module.exports = __webpack_public_path__ + "static/media/window.8d4918ac.png";